<template>
  <div class="main h-screen min-h-0 w-full bg-[#f3f3f3] grid grid-cols-1 
  overflow-y-auto overflow-x-hidden"
      :class="sidebarOpen
        ? 'md:[grid-template-columns:25%_75%] lg:[grid-template-columns:20%_80%] xl:[grid-template-columns:15%_85%]'
        : 'md:[grid-template-columns:100%] lg:[grid-template-columns:100%] xl:[grid-template-columns:100%]'"
  
  >
    <!-- <div
      class="fixed bg-[rgba(0,0,0,0.5)] h-full w-full z-[10000] flex justify-center items-center"
      v-if="loading || (mobileDevice && sidebarOpen)"
    >
      <div class="spinner h-[50px] w-[50px] rounded-full" v-if="loading"></div>
    </div> -->
    <!-- Sidebar as overlay on mobile -->
    <Transition name="sidebar-slide">
      <Sidebar v-if="mobileDevice && sidebarOpen" :navigation="navigation" class="fixed left-0 top-0 h-[100vh] w-[80vw] max-w-xs h-screen z-[11100] md:hidden" />
    </Transition>
    <!-- Sidebar as grid column on desktop -->
    <Transition name="sidebar-slide">
      <Sidebar v-if="!mobileDevice && sidebarOpen" :navigation="navigation" class="h-full" />
    </Transition>
    <div
      class="flex flex-col border-1 flex-1 h-full min-h-0"
      :class="{ mobileDevice: mobileDevice, desktop: !mobileDevice }"
    >
      <Header />
      <div class="h-full flex-1 w-full mx-auto heightClass overflow-y-auto min-h-0">
        <div
          class="w-full mx-auto h-full"
          :class="sidebarOpen ? 'max-w-[1920px]' : 'max-w-full'"
        >
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { onMounted, onUnmounted, ref } from "vue";
import Header from "./components/Header.vue";
import Sidebar from "./components/Sidebar.vue";
import { useMainStore } from "./store";

const store = useMainStore();
const { navigation, loading, mobileDevice, sidebarOpen, permissions } =
  storeToRefs(store);
const screenWidth = ref(window.innerWidth);
const screenHeight = ref(window.innerHeight);

const updateScreenSize = () => {
  screenWidth.value = window.innerWidth;
  screenHeight.value = window.innerHeight;
  mobileDevice.value = window.innerWidth <= 767;
};

onMounted(() => {
  updateScreenSize();
  window.addEventListener("resize", updateScreenSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateScreenSize);
});
</script>

<style lang="scss">
.heightClass {
  height: calc(100vh - 53px);
}
.desktop {
  width: 100%;
}
.mobileDevice {
  width: 100vw;
}
.spinner {
  border: 5px solid #00b087;
  border-top-color: transparent;
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
}
.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition:
    opacity 0.3s,
    transform 0.3s;
}
.sidebar-slide-enter-from,
.sidebar-slide-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.sidebar-slide-enter-to,
.sidebar-slide-leave-from {
  opacity: 1;
  transform: translateX(0);
}
</style>
